import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import SortedTooltip from './SortedTooltip';

interface TrendData {
  stores: string[];
  data: Record<string, string | number>[];
}

interface Props {
  trend: TrendData;
}

const COLORS = ['#6366f1', '#f59e0b', '#10b981', '#3b82f6', '#ef4444'];

const StoresSalesTrendChart = ({ trend }: Props) => {
  if (!trend?.stores?.length) {
    return (
      <div className="bg-white rounded-lg shadow p-4 flex items-center justify-center" style={{ height: 260 }}>
        <p className="text-sm text-gray-500">No store sales data available</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-4 w-full">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Top 5 Stores — Last 6 Months</h3>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={trend.data} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="month" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip content={<SortedTooltip />} />
          <Legend />
          {trend.stores.map((store, index) => (
            <Line
              key={store}
              type="monotone"
              dataKey={store}
              stroke={COLORS[index % COLORS.length]}
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 5 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StoresSalesTrendChart;
